<template>
  <page :title="`${department.name} Work Crews`">
    <template #actions>
      <div>
        <Button text="Create Crew Member" @click="toggleModal" />
      </div>
    </template>
    <div
      class="p-4 py-4 d-flex rounded-borders crews-board flex-col md:flex-row"
    >
      <work-crew-groups class="full-width" :links="links"></work-crew-groups>
      <divider vertical class="divider hidden md:block"></divider>
      <crew-members></crew-members>
    </div>
    <crew-member-modal
      v-if="createModal"
      :link="links.crew_member_create"
      @hide-modal="toggleModal"
    ></crew-member-modal>
  </page>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Button from "@/components/Button.vue";
import Divider from "@/components/Divider.vue";
import Page from "@/components/Page.vue";
import CrewMemberModal from "./CrewMemberModal.vue";
import CrewMembers from "./CrewMembers.vue";
import WorkCrewGroups from "./WorkCrewGroups.vue";

export default {
  components: {
    Page,
    WorkCrewGroups,
    CrewMembers,
    Button,
    Divider,
    CrewMemberModal
  },
  props: {
    department: {
      type: Object,
      default: () => ({})
    },
    links: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      createModal: false
    };
  },
  mounted() {
    EventBus.$on("refresh-work-crews", this.getCrewMembers);
    this.setDepartment(this.department);
    this.fetchTechnicians();
    this.getCrewMembers();
  },
  beforeUnmount() {
    EventBus.$off("refresh-work-crews", this.getCrewMembers);
  },
  methods: {
    ...mapActions(["fetchTechnicians", "fetchCrewMembers", "setDepartment"]),
    getCrewMembers() {
      this.fetchCrewMembers({
        link: this.links.crew_member_list
      });
    },
    toggleModal() {
      this.createModal = !this.createModal;
    }
  }
};
</script>

<style lang="scss" scoped>
.crews-board {
  height: 85vh;
  box-shadow: var(--box-shadow);
  background-color: #fff;
}
.divider {
  margin-top: 50px !important;
}
</style>
